<script setup lang="ts">
const emit = defineEmits<{
  (event: 'submit', value: object): void;
}>();
</script>

<template>
  <form @submit.prevent="emit('submit', $event)">
    <slot />
  </form>
</template>
